import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { NotesProvider } from "./context/NotesContext";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <NotesProvider>
                <App />
            </NotesProvider>
        </BrowserRouter>
    </React.StrictMode>
);

reportWebVitals();
